import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Axios from "axios";
import { toast } from "react-toastify";
import Loader from "../Loader";
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import styles from "./PhoneRecovery.module.css";
import { Urls } from "../../Urls";

const PhoneRecovery = () => {
  const [phoneNumber, setPhoneNumber] = useState("")
  const [loading, setLoading] = useState(false);
  const [verifyingToken, setVerifyingToken] = useState(true);
  const [tokenError, setTokenError] = useState(null);

  const [resetComplete, setResetComplete] = useState(false)

  const location = useLocation();
  const history = useHistory();

  // Extract token from URL search params: ?token=xxxx
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  useEffect(() => {
    if (!token) {
      setTokenError("Please use the link sent to your registered email.");
      setVerifyingToken(false);
      return;
    }

    setVerifyingToken(false);
  }, [token]);

  const handleUpdatePhone = async (e) => {
    e.preventDefault();

    if (!phoneNumber || !isValidPhoneNumber(phoneNumber)) {
      toast.error("Invalid phone number format. Please ensure you have selected the correct country.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await Axios.post(`${Urls.MFA_LORRI}?token=${token}`, {
        phone_number: phoneNumber
      });
      if (data?.status) {
        toast.success("Phone number updated successfully! You can now sign in.");
        setResetComplete(true)
      } else {
        toast.error(data?.error || "Failed to update phone number.");
      }
    } catch (err) {
      console.error("Phone recovery error:", err);
      const errorMsg = err.response?.data?.error || "An error occurred during recovery. The link may be expired.";
      toast.error(errorMsg);
      if (err.response?.status === 401 || err.response?.status === 404) {
        setTokenError(errorMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  if (verifyingToken) {
    return <Loader show={true} />;
  }

  return (
    <div className={styles.recoveryContainer}>
      <Loader show={loading} />

      <div className={styles.recoveryCard}>
        <div className={styles.logoContainer}>
          <img 
            alt="logo" 
            src={Urls.LorriLogoLogin}
            className={styles.logoImage} 
          />
        </div>

        <h2 className={styles.title}>
          Reset Phone Number.
        </h2>

        {tokenError ? (
          <div className={styles.errorBox}>
            <p className={styles.errorTitle}>Link Invalid or Expired</p>
            <p className={styles.errorMessage}>{tokenError}</p>
            <button
              onClick={() => history.push("/login")}
              className={styles.backButton}
            >
              Back to Login
            </button>
          </div>
        ) : (
          <>
            {
              !resetComplete && <>
                <p className={styles.description}>
                  Enter your new phone number to enroll it as your primary Multi-Factor Authentication factor.
                </p>
                <form onSubmit={handleUpdatePhone}>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>
                      New Phone Number
                    </label>
                    <div style={{ marginBottom: "15px" }}>
                      <PhoneInput
                        placeholder="Enter new phone number"
                        defaultCountry="IN"
                        value={phoneNumber}
                        onChange={setPhoneNumber}
                        className={styles.input}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                          background: "white",
                          borderRadius: "4px",
                          border: "1px solid #ddd"
                        }}
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className={styles.submitButton}
                  >
                    {loading ? "Updating..." : "Update"}
                  </button>
                </form>
              </>
            }

            {
              resetComplete &&
              <>
                <p>Reset was successful. You can sign in now.</p>
                <button
                  onClick={() => history.push("/login")}
                  className={styles.cancelButton}
                >
                  Sign In
                </button>
              </>

            }
          </>
        )}
      </div>
    </div>
  );
};

export default PhoneRecovery;